import type { MoMSalesReportPeriodOption } from './types';
import { formatMoney } from '../reports/formatters';

export const getDefaultBasePeriod = (
  periods: MoMSalesReportPeriodOption[],
  reportingPeriod: string | null
): string | null => {
  if (periods.length < 2) return null;

  return periods.find((period) => period.value !== reportingPeriod)?.value ?? null;
};

export const formatVariance = (value: number): string => {
  const formatted = formatMoney(Math.abs(value));
  return value > 0 ? `+${formatted}` : value < 0 ? `-${formatted}` : formatted;
};

export const getVarianceColor = (value: number): 'error.main' | 'success.main' | 'text.primary' => {
  if (value > 0) return 'success.main';
  if (value < 0) return 'error.main';
  return 'text.primary';
};
